<div class="flex flex-col h-full">
  <div class="flex justify-between items-center mb-6 gap-4">
    <div class="flex items-center gap-4">
      <div class="w-64">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-search" />
          <input 
            type="text" 
            pInputText 
            [formControl]="searchControl"
            [placeholder]="'search' | translate" 
            class="w-full" />
        </p-iconField>
      </div>
      
      <p-datepicker 
        [formControl]="startDateControl" 
        [placeholder]="'start_date' | translate"
        [showIcon]="true"
        [showClear]="true"
        fluid="true"
        class="w-44">
      </p-datepicker>
      
      <p-datepicker 
        [formControl]="endDateControl" 
        [placeholder]="'end_date' | translate"
        [showIcon]="true"
        [showClear]="true"
        fluid="true"
        class="w-44">
      </p-datepicker>
    </div>
    
    <app-button *hasPermission="'Laboratórios:create'"
      [label]="'laboratory_new_order' | translate"
      icon="pi pi-plus"
      (onClick)="onNewOrder()">
    </app-button>
  </div>

  <div class="flex-1 overflow-hidden">
    <app-prime-table
      [data]="orders"
      [columns]="columns"
      [loading]="loading"
      [totalRecords]="totalRecords"
      [rows]="rows"
      [lazy]="true"
      [paginator]="true"
      (onPage)="onPageChange($event)"
      [templates]="templates">
    </app-prime-table>
  </div>
</div>

<app-laboratory-order-modal
  [(visible)]="showNewOrderModal"
  [orderToEdit]="orderToEdit"
  (saved)="onOrderSaved()">
</app-laboratory-order-modal>

<p-confirmDialog #cd [style]="{width: '450px'}" appendTo="body">
    <ng-template pTemplate="footer">
        <app-button 
            type="button" 
            variant="secondary" 
            [label]="cd.rejectButtonLabel || ('NO' | translate)" 
            (onClick)="cd.onReject()">
        </app-button>
        <app-button 
            type="button" 
            variant="primary" 
            [label]="cd.acceptButtonLabel || ('YES' | translate)" 
            (onClick)="cd.onAccept()">
        </app-button>
    </ng-template>
</p-confirmDialog>

<app-laboratory-order-details
  [(visible)]="showDetailsModal"
  [order]="selectedOrder"
  (statusChanged)="onStatusChanged()">
</app-laboratory-order-details>

<ng-template #statusTpl let-item>
  <span class="px-2 py-1 rounded-full text-xs font-medium" [ngClass]="getStatusColor(item.status_name)">
    {{ getOrderStatusKey(item.status_name) | translate }}
  </span>
</ng-template>


<ng-template #actionsTpl let-item>
  <app-dropdown>
    <ng-template #trigger>
      <button pButton icon="pi pi-ellipsis-v" class="p-button-text p-button-rounded p-button-secondary h-8 w-8"></button>
    </ng-template>
    <ng-template #content>
      <div class="flex flex-col min-w-[150px] py-1">
        <button 
            (click)="onViewDetails(item)"
            class="flex items-center gap-2 px-4 py-2 hover:bg-slate-50 w-full text-left text-sm text-slate-700 transition-colors">
            <i class="pi pi-eye text-slate-400"></i>
            {{ 'view' | translate }}
        </button>
        <button *hasPermission="'Laboratórios:edit'"
            (click)="onEditOrder(item)"
            class="flex items-center gap-2 px-4 py-2 hover:bg-slate-50 w-full text-left text-sm text-slate-700 transition-colors">
            <i class="pi pi-pencil text-slate-400"></i>
            {{ 'edit' | translate }}
        </button>
        <button *hasPermission="'Laboratórios:delete'"
            (click)="onDeleteOrder(item)"
            class="flex items-center gap-2 px-4 py-2 hover:bg-red-50 w-full text-left text-sm text-red-600 transition-colors">
            <i class="pi pi-trash text-red-400"></i>
            {{ 'delete' | translate }}
        </button>
      </div>
    </ng-template>
  </app-dropdown>
</ng-template>
